import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getSku = params => {
  return axios.request({
    url: "/warehouse/sku",
    method: "get",
    params
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/warehouse/sku",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/warehouse/sku/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/warehouse/sku/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/warehouse/sku/${id}`,
    method: "DELETE"
  });
};


export const getBarcode = data => {
  return axios.request({
    url: `/warehouse/sku/getBarcode`,
    method: "post",
    data
  });
};

export function uploadFlieSku(data) {
  return axios.request({
    url: "/warehouse/sku/batchSku",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
}

